export default "__VITE_ASSET__0VNpnb44__"